// kh-header.js — Aufklappmenue, Suchzeile, Schublade und Warenkorbzaehler.
//
// Bewusst ohne Abhaengigkeit zu GSAP oder zu Horizons Komponenten:
// der Header ist das erste Element der Seite und muss auch dann
// bedienbar sein, wenn eine spaeter geladene Bibliothek ausfaellt.

(function () {
  'use strict';

  var root = document.querySelector('[data-kh-header]');
  if (!root) return;

  /* ── Hoehe als CSS-Variable ──
     Horizon rechnet an mehreren Stellen mit --header-height: base.css,
     header-actions, product-information-content und section.liquid. Dazu
     kommt die Produktgalerie (.kh-pd__galerie in kh-b2b.css). Jede
     Aenderung loest damit ein Layout der ganzen Seite aus.

     Deshalb aendert sich die Kopfhoehe seit dem 07.09.2026 beim Scrollen
     ueberhaupt nicht mehr: die Servicezeile klappt nicht mehr ein. Sie tat
     es frueher ueber eine max-height-Transition von 0,28 s, und dabei
     feuerte der ResizeObserver bei JEDEM Frame und schrieb Zwischenwerte
     wie "95.890625px" -- gemessen am 02.09.2026 zwoelf Schreibvorgaenge
     bei einem Auf und Ab, von denen nur zwei einen Zustand beschrieben,
     den die Seite je einnimmt. Das war das Haengen beim Scrollen.

     Der Zwischenstands-Filter (transitionrun/transitionend) ist mit dem
     Einklappen weggefallen -- ohne Transition gibt es nichts zu filtern.
     Wer das Einklappen zurueckholt, braucht ihn wieder, und zusaetzlich
     eine Loesung fuer den Sprung, den die geaenderte Kopfhoehe bei allem
     ausloest, was an ihr haengt. Siehe kh-header.css.

     Was bleibt, deckt Drehen des Geraets und Umbrueche ab:
     1. Auf ganze Pixel gerundet -- krumme Werte erzwingen Subpixel-Layout.
     2. Nur schreiben, wenn sich der Wert tatsaechlich geaendert hat, und
        gedrosselt auf einen Frame. */
  var letzteHoehe = -1;
  var hoehenTick = false;

  function publishHeight() {
    if (hoehenTick) return;
    hoehenTick = true;
    window.requestAnimationFrame(function () {
      hoehenTick = false;
      var h = Math.round(root.getBoundingClientRect().height);
      if (h === letzteHoehe) return;
      letzteHoehe = h;
      document.body.style.setProperty('--header-height', h + 'px');
      document.body.style.setProperty('--header-group-height', h + 'px');
    });
  }

  publishHeight();
  window.addEventListener('resize', publishHeight);
  if (window.ResizeObserver) new ResizeObserver(publishHeight).observe(root);

  /* ── Marken-Aufklappmenue ── */
  var dropdowns = [].slice.call(root.querySelectorAll('[data-kh-dropdown]'));

  function closeDropdowns(except) {
    dropdowns.forEach(function (d) {
      if (d === except) return;
      d.setAttribute('data-open', 'false');
      var btn = d.querySelector('button');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  dropdowns.forEach(function (d) {
    var btn = d.querySelector('button');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = d.getAttribute('data-open') === 'true';
      closeDropdowns(d);
      d.setAttribute('data-open', open ? 'false' : 'true');
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
    // Zeigegeraete mit Hover: aufklappen ohne Klick, aber der Klick bleibt.
    d.addEventListener('mouseenter', function () {
      if (window.matchMedia('(hover: hover)').matches) {
        closeDropdowns(d);
        d.setAttribute('data-open', 'true');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
    d.addEventListener('mouseleave', function () {
      if (window.matchMedia('(hover: hover)').matches) {
        d.setAttribute('data-open', 'false');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.addEventListener('click', function () { closeDropdowns(null); });

  /* ── Suchzeile auf dem Handy ── */
  var searchToggle = root.querySelector('.kh-hd-search-toggle');
  var searchRow = root.querySelector('#kh-hd-search-row');
  if (searchToggle && searchRow) {
    searchToggle.addEventListener('click', function () {
      var open = searchRow.classList.toggle('kh-hd-open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      publishHeight();
      if (open) {
        var input = searchRow.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* ── Schublade ── */
  var drawer = document.getElementById('kh-hd-drawer');
  var scrim = document.querySelector('[data-kh-scrim]');
  var burger = root.querySelector('.kh-hd-menu-btn');
  var closeBtn = drawer ? drawer.querySelector('.kh-hd-drawer-close') : null;
  var lastFocus = null;

  function setDrawer(open) {
    if (!drawer || !scrim) return;
    if (open) lastFocus = document.activeElement;
    drawer.classList.toggle('kh-hd-open', open);
    scrim.classList.toggle('kh-hd-open', open);
    // hidden erst nach der Blende entfernen, sonst gibt es keinen Uebergang
    if (open) scrim.hidden = false;
    else window.setTimeout(function () { if (!scrim.classList.contains('kh-hd-open')) scrim.hidden = true; }, 260);

    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (burger) {
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      // Beschriftung aus data-label-zu/-auf (Sprachschluessel im Liquid), Deutsch nur als Rueckfall.
      burger.setAttribute('aria-label', open ? (burger.dataset.labelZu || 'Menü schließen') : (burger.dataset.labelAuf || 'Menü öffnen'));
    }
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open && closeBtn) closeBtn.focus();
    if (!open && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  if (burger) burger.addEventListener('click', function () {
    setDrawer(!drawer.classList.contains('kh-hd-open'));
  });
  if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
  if (scrim) scrim.addEventListener('click', function () { setDrawer(false); });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDropdowns(null);
    if (drawer && drawer.classList.contains('kh-hd-open')) setDrawer(false);
  });

  // Beim Wechsel auf breite Bildschirme darf keine offene Schublade
  // zurueckbleiben — sonst haengt der Scroll-Lock am Dokument fest.
  // Die Breite muss zur CSS-Schwelle passen: ab 1024 px traegt die Leiste
  // die Navigation selbst, der Menue-Knopf ist dort ausgeblendet. Stand
  // hier weiter 900, blieb die Schublade zwischen 900 und 1023 px offen,
  // ohne dass es noch einen sichtbaren Knopf zum Schliessen gab.
  window.matchMedia('(min-width: 1024px)').addEventListener('change', function (e) {
    if (e.matches) setDrawer(false);
  });

  /* ── Warenkorbzaehler ──
     Serverseitig gerendert, aber Shopify liefert Seiten aus dem Cache aus.
     Ein Abgleich gegen /cart.js verhindert eine veraltete Zahl. */
  function refreshCart() {
    var badges = document.querySelectorAll('[data-kh-cart-count]');
    if (!badges.length) return;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        badges.forEach(function (b) {
          b.textContent = c.item_count;
          b.hidden = c.item_count === 0;
        });
      })
      .catch(function () { /* Zaehler bleibt auf dem serverseitigen Wert */ });
  }
  refreshCart();
  ['cart:update', 'cart:refresh', 'variant:add'].forEach(function (evt) {
    document.addEventListener(evt, refreshCart);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
})();
